import {getDateOfCertainFormat} from "@/helpers/date"

import Cookies from "vue-cookies";

export default {
    methods: {
        dateToString(date) {
            if(date === null) {
                return '';
            }

            if (!(date instanceof Date) || isNaN(date)) {
                console.error("invalid date " + date);
                return '';
            }

            const userLocale = navigator.language;
            const formattedDate = new Intl.DateTimeFormat(userLocale, {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              }).format(date);

              return formattedDate;

            
            //return date ? getDateOfCertainFormat(date, format) : ''
        },
        dateToFormat(date, format) {
            return date ? getDateOfCertainFormat(date, format) : ''
        },
        getUser() {
            try {
                let cookie = Cookies.get('jwt');

                if(cookie === null){
                    return null;
                }

                return JSON.parse(atob(cookie.token.split('.')[1]));
            }
            catch (e) {
                return null;
            }
        },
        hasPermission(permission){
            let user = this.getUser();

            if (user === null) {
                return false;
            }

            let permissions = user.permissions;
            if (permissions === undefined) {
                return false;
            }

            return permissions.includes(permission);
        },
        hasRole(role){
            let user = this.getUser();
            if (user === null) {
                return false;
            }

            return user.roles === role;
        },
        handleErrorResponse(error){
            if(error.response.status === 400 && error.response.data.code === 'validation_error') {
                this.$toast.add({severity: 'error', summary: 'Data entry error', life: 3000});

                return;
            }
            else if(error.response.status === 400) {
                this.$toast.add({severity: 'error', summary: error.response.data, life: 3000});

                return;
            }

            throw error;
        },
        isBackoffice() {
            return window.application === 'backoffice';
        },
        getLocales(){
            let user = this.getUser();

            if (user === null) {
                return false;
            }

            let langages = user.languages;
            if (langages === undefined) {
                return ['en'];
            }

            return Array.isArray(langages) ? langages : [langages];


            // if(this.hasPermission('multi_language_editor')){
            //     return ['en', 'ru'];
            // }

            // return ['en'];
        },
        isLocales(){
            return this.hasPermission('multi_language_editor');
        },
        getCurrencies() {
            return {
                "RUB": {
                    "number": "643",
                    "code": "RUB",
                    "symbolUtf8": "₽"
                },
                "EUR": {
                    "number": "978",
                    "code": "EUR",
                    "symbolUtf8": "€"
                },
                "USD": {
                    "number": "840",
                    "code": "USD",
                    "symbolUtf8": "$"
                },
                "GBP": {
                    "number": "826",
                    "code": "GBP",
                    "symbolUtf8": "£"
                }
            };
        },
        getCurrency(code) {
            return this.getCurrencies()[code];
        }
    }
}
